import type { ReactNode } from 'react';
import './page-wrapper.scss';

type PageWrapperProps = {
    children: ReactNode;
};

export const PageWrapper = ({ children }: PageWrapperProps) => <div className="page-wrapper">{children}</div>;
